import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class PigmentService {
	private db;
	pigments: FirebaseListObservable<Pigment[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadPigments();
		
	}

	/**
	 * Load initial data
	 */
	loadPigments() {
		window.dispatchEvent(new Event('loading'));
		this.pigments = this.db.list('/pigments') as FirebaseListObservable<Pigment[]>
		this.pigments.subscribe(data => {
			this.triggerDataChange();
		});

		return this.pigments;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Pigments
	 */
	getPigments() {
		return this.pigments;
	}

	/**
	 * Get Pigment by ID
	 * @param {string} id : Item ID
	 */
	getPigment(id:string) {
		return this.db.object('/pigments/'+id) as FirebaseObjectObservable<Pigment>;
	}

	/**
	 * Add new Pigment
	 * @param {Pigment} pigment
	 */
	addPigment(pigment) {
		return this.pigments.push(pigment);
	}

	/**
	 * Update Pigment Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updatePigment(id:string, data:Pigment) {
		var pigment = this.getPigment(id);
		data.updated_at = (new Date()).getTime();
		return pigment.update(data);
	}

	/**
	 * Delete Pigment
	 * @param {string} id : Item ID
	 */
	deletePigment(id:string) {
		var promise = new Promise<any>((resolve, reject) => {
			if(!id){
				reject('ID must provided.');
			}
			else
			{
				var result = this.pigments.remove(id).then(data => {
					this.triggerDataChange();
					resolve(data);
				})
			}
		})
		return promise;
	}
}

export class Pigment {
	$key?:string;
	name?:string = '';

	created_at?:number;
	updated_at?:number;

	constructor()
	{
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}




// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/pigment.service.ts